import { appendAPExamTemplate } from '@/functions/idp'
import RIC from './RIC_1'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
